import React, { useEffect, useState } from 'react';

interface FooterProps {
  showSidebar?: boolean;
}

export default function Footer({ showSidebar = false }: FooterProps) {
  // Initialize dark mode state from localStorage
  const [isDarkMode, setIsDarkMode] = useState<boolean>(() => {
    const theme = localStorage.getItem("theme");
    if (theme) {
      return theme === "dark";
    }
    return window.matchMedia("(prefers-color-scheme: dark)").matches;
  });

  // Update when theme changes in localStorage
  useEffect(() => {
    const handleStorageChange = (e: StorageEvent) => {
      if (e.key === 'theme') {
        setIsDarkMode(e.newValue === 'dark');
      }
    };

    window.addEventListener('storage', handleStorageChange);
    return () => window.removeEventListener('storage', handleStorageChange);
  }, []);

  // Also check for the dark class on the HTML element
  useEffect(() => {
    const observer = new MutationObserver(() => {
      const hasDarkClass = document.documentElement.classList.contains('dark');
      setIsDarkMode(hasDarkClass);
    });

    observer.observe(document.documentElement, { attributes: true });
    return () => observer.disconnect();
  }, []);

  return (
    <footer className={`${isDarkMode ? 'bg-neutral-dark text-gray-100' : 'bg-white text-gray-900'} py-8 ${showSidebar ? 'lg:pl-64' : ''}`}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col items-center space-y-4 sm:flex-row sm:justify-between sm:space-y-0">
          <div className="text-sm text-center sm:text-left">
            &copy; {new Date().getFullYear()} Swiftclear Technologies. All rights reserved.
          </div>
          <div className="flex space-x-4">
            <a
              href="/privacy-policy"
              className={`${isDarkMode ? 'text-gray-400 hover:text-gray-200' : 'text-gray-500 hover:text-gray-700'}`}
            >
              Privacy Policy
            </a>
            <a
              href="/terms-of-service"
              className={`${isDarkMode ? 'text-gray-400 hover:text-gray-200' : 'text-gray-500 hover:text-gray-700'}`}
            >
              Terms of Service
            </a>
            <a
              href="/contact-us"
              className={`${isDarkMode ? 'text-gray-400 hover:text-gray-200' : 'text-gray-500 hover:text-gray-700'}`}
            >
              Contact Us
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
